export default "assets/images/logo-cabe5b86.png";